const templates = require.context('./ja/', true, /\.json$/)
let langMap = {}

for (let i = 0; i < templates.keys().length; i++) {
  const key = templates.keys()[i]
  langMap = Object.assign(langMap, templates(key))
}

export default { ...langMap }
